import React from 'react';
export const Play = (props) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", ...props },
        React.createElement("circle", { cx: "15", cy: "15", r: "14.25", stroke: "currentColor", strokeWidth: "1.5" }),
        React.createElement("path", { d: "M12.5 9.5L20 15L12.5 20.5V9.5Z", fill: "currentColor" })));
};
